import { ASTREA_ENVIRONMENTS } from '../../shared/context/astreaEnvironments'

/**
 * Port of `app/banner/bannerConstants.js` (AngularJS `BANNER_CONSTANTS`
 * constant). Values are copied 1:1 from the legacy module; only the
 * `HOMOLOG_URLS` list is re-expressed using the already-existing
 * `ASTREA_ENVIRONMENTS` constant (`shared/context/astreaEnvironments.js`,
 * task 009) instead of re-introducing the same three literal strings
 * (`"HOMOLOG"`, `"LOCAL"`, `"PLAYGROUND"`) a second time — the legacy
 * list and `ASTREA_ENVIRONMENTS` already match exactly.
 *
 * `ENVS`/`ENV_LABELS`/`BASE_URL` mirror the backend's
 * `server_app/constants/bannerLogin.js` (`BANNER_ENVS`, `BANNER_ENV_LABELS`,
 * `BANNER_BASE_URL`) — the backend is the source of truth for the S3 key
 * layout, but the frontend needs its own copies of the same small set of
 * values to resolve which env it's talking to and build the public banner
 * image URL, exactly like the legacy AngularJS controller did.
 */
export const BANNER_CONSTANTS = {
  MAX_FILE_SIZE: 3 * 1024 * 1024,
  ALLOWED_MIMETYPE: 'image/webp',
  TOAST_AUTO_HIDE_DURATION: 5000,
  HOMOLOG_URLS: [
    ASTREA_ENVIRONMENTS.HOMOLOGATION,
    ASTREA_ENVIRONMENTS.LOCAL,
    ASTREA_ENVIRONMENTS.PLAYGROUND,
  ],
  ENVS: {
    HOMOLOG: 'homolog',
    PRODUCTION: 'v2',
  },
  ENV_LABELS: {
    v2: 'PROD',
  },
  BASE_URL: 'https://publico.aurum.com.br/img',
}

export default BANNER_CONSTANTS
